import { parse } from 'papaparse';

export const useParseFile = () => {
  const parseFile = (file: File) => {
    return new Promise<string[]>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const dataString = event?.target?.result as string;
        let enterpriseIds: string[] = [];
        parse(dataString.trim(), {
          header: false,
          dynamicTyping: true,
          skipEmptyLines: true,
          delimiter: '\r\n',
          worker: true,
          complete: (results: { data: any[]; errors: string | any[] }) => {
            if (results && results.errors && results?.errors?.length) {
              console.error('Parse File Errors while parsing:', results.errors);
              reject(results.errors);
            } else {
              const flattenedData = [].concat(...(results?.data ?? []));
              if (flattenedData.length === 0) {
                reject('No data found in the file.');
              } else if (flattenedData.length > 500) {
                reject('File contains more than 500 records.');
              } else if (!flattenedData.every((item) => !isNaN(Number(item)))) {
                reject('File contains non-numeric data.');
              } else {
                // eslint-disable-next-line no-unsafe-optional-chaining
                console.log('Parse File Results:', [].concat(...(results?.data ?? [])).map(String));
                enterpriseIds = flattenedData.map(String);
                resolve(enterpriseIds);
              }
            }
          },
        });
      };
      reader.readAsText(file);
    });
  };

  return parseFile;
};
